var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('iframe',{staticClass:"fullscreen-iframe",on:{"load":_setup.loadEnded}})
}
var staticRenderFns = []

export { render, staticRenderFns }